export default function Card({ title, children, right, id }) {
  return (
    <section className="bg-white rounded-2xl border border-[#d2d2d7] overflow-hidden" data-testid={`portal-section-${id}`}>
      <header className="flex items-center justify-between px-5 md:px-6 py-4 border-b border-[#d2d2d7]">
        <h2 className="text-[15px] font-semibold text-[#1d1d1f]">{title}</h2>
        {right}
      </header>
      <div className="p-5 md:p-6">{children}</div>
    </section>
  );
}
